'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isWeekday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isWeekday.js
// module id = 253
// module chunks = 1